export enum ApiRoutesProfile {
  Me = "admin/me"
}

export enum ApiRoutesCommon {
  AllDeliveryZones = "/general/delivery-zones/all"
}

export enum ModeratorRoutesPrivileges {
  Dashboard = "Dashboard",
  Resellers = "Resellers",
  Categories = "Categories",
  Orders = "Orders",
  Returns = "Returns",
  Products = "Products",
  ProductSets = "ProductSets",
  SpecialOffers = "SpecialOffers",
  Banners = "Banners",
  Coupons = "Coupons",
  SharingSchedule = "SharingSchedule",
  Insights = "Insights",
  Inventory = "Inventory",
  Financial = "Financial",
  Notification = "Notification",
  Verification = "Verification",
  Drivers = "Drivers",
  Content = "Content",
  StaffManagement = "StaffManagement",
  AiAssistants = "AiAssistants",
  Marketing = "Marketing",
  ActivityLog = "ActivityLog",
  CriticalAlerts = "CriticalAlerts",
  EmailNotifications = "EmailNotifications"
}

export enum StaffManagerPermissions {
  CreateProducts = "CreateProducts",
  UpdateProducts = "UpdateProducts",
  DeleteProductVariants = "DeleteProductVariants",
  ChangeProductVariantVisibilityForResellers = "ChangeProductVariantVisibilityForResellers",
  BlockResellers = "BlockResellers",
  UnblockResellers = "UnblockResellers",
  DeleteResellers = "DeleteResellers",
  RestoreResellers = "RestoreResellers",
  AcknowledgeAuditAlerts = "AcknowledgeAuditAlerts",
  ManageEmailNotificationRecipients = "ManageEmailNotificationRecipients",
  ManageAiLessons = "ManageAiLessons"
}
